import { ApolloClient, InMemoryCache, HttpLink } from '@apollo/client';

const client = new ApolloClient({
  link: new HttpLink({
    // uri :"http://localhost:8080/graphql",
    //local
    uri:'https://gcp-poc-with-apollo-1081525845464.asia-south1.run.app/graphql',   
  }),
  cache: new InMemoryCache(),
});

export default client;
